module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 130.60ce0fa3.png";